import { render, staticRenderFns } from "./IntroScreen.vue?vue&type=template&id=6fa4adc5&scoped=true&lang=pug&"
import script from "./IntroScreen.vue?vue&type=script&lang=js&"
export * from "./IntroScreen.vue?vue&type=script&lang=js&"
import style0 from "./IntroScreen.vue?vue&type=style&index=0&id=6fa4adc5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4adc5",
  null
  
)

export default component.exports